import React, { useEffect } from 'react'
import { RouteComponentProps, useParams } from 'react-router'

import useMyhouse from '@Hooks/myhouse/useMyhouse'
import MyhouseReviewListPage from '@Components/templates/MyhouseReviewListPage'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import { getDeniedPath, LAND_DENIED_TYPE } from '@Root/contants/myhouseError'

function ReviewListPage(props: RouteComponentProps<any>) {
  const params = useParams<{ complexNo: string }>()
  const complexNo = parseInt(params.complexNo)

  const { setComplexNo, isLoaded, isRegistrationExists } = useMyhouse()

  useEffect(() => {
    setComplexNo(complexNo)
  }, [complexNo])

  if (!complexNo) {
    props.history.replace(getDeniedPath(LAND_DENIED_TYPE.BBS_NOT_INCLUDE_COMPLEX_NO))
  }

  useEffect(() => {
    // 리뷰 읽기 권한이 없는 경우. 등록 가이드로
    if (isLoaded && !isRegistrationExists) {
      props.history.replace(`${LAND_SERVICE_PREFIX_URL.MYHOUSE}/regist/guide`)
    }
  }, [isLoaded])

  return <MyhouseReviewListPage />
}
export default ReviewListPage
